// removed by extract-text-webpack-plugin
module.exports = {"option":"option___2WgIH"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/StringEditor/styles.scss
// module id = 439
// module chunks = 0